// This file is separated from Sidepanel.tsx because createBatchLink depends on this query to construct the
// correct network request batching logic. createApolloClient (which imports createBatchLink) is imported by a
// lot of places, so keep try to keep the dependency graph somewhat sane.
import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const ALL_INVENTORY_SCHEMAS_QUERY: DocumentNode = gql`
  query AllInventorySchemasQuery @skipAudit @engComponent(name: INVENTORY) {
    ...AllStorableSchemasGraphQL
  }
  ${getFragmentWrapper('AllStorableSchemas').fragment}
`;

// Separate assay schemas from inventory schemas, since there's no benefit of grouping them, and we want to
// parallelize the slow queries.
export const ALL_ASSAY_SCHEMAS_QUERY: DocumentNode = gql`
  query AllAssaySchemasQuery @skipAudit @engComponent(name: RESULTS) {
    ...AllAssaySchemasGraphQL
  }
  ${getFragmentWrapper('AllAssaySchemas').fragment}
`;
